module.exports = "<button mat-fab color=\"primary\" (click)=\"newRelease()\" [disabled]=\"isProcessing\">\n  <mat-icon>add</mat-icon>\n</button>\n"